import React from "react";
import styles from "./spinner.module.css";
export const Spinner = () => {
  return <div className={styles.loader}>Loading...</div>;
};

export default Spinner;
